<template>
	<el-dialog :style="{ '--el-dialog-padding-primary': 0 }" :title="richTitle" class="rich-text-edit-dialog" v-model="dialogVisible" append-to-body :width="width">
		<custom-text-edit v-if="dialogVisible" ref="customTextEditRef" v-model:text="formData"
			v-model:functionParms="functionParms" :customData="customData" :currentParms="currentParms"
			:isTitleSet="isTitleSet" :formField="formField" :isReadonly="isReadonly"
			:isAppendRightTools="isAppendRightTools" :showCustom="showCustom" />
		<template #footer>
			<div class="dialog-footer" style="padding: 10px 10px 10px 0;" v-if="!isReadonly">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">提 交</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
	data() {
		return {
			dialogVisible: false,
			appData: {},
			formData: '',
			index: 0,
			functionParms: [],
			customData: []
		}
	},
	props: {
		isApp: {
			type: Boolean,
			default: false
		},
		richTitle: {
			type: String,
			default: '富文本编辑'
		},
		currentParms: {
			type: Object,
			default: () => { return {} }
		},
		// 是否标题设置进来
		isTitleSet: {
			type: Boolean,
			default: false
		},
		formField: {
			type: Array,
			default: () => ([])
		},
		// 是否显示页面传参（AI小易设置不显示）
		showCustom: {
			type: Boolean,
			default: true
		},
		isReadonly: {
			type: Boolean,
			default: false
		},
		isAppendRightTools: {
			type: Boolean,
			default: true
		},
		width: {
			type: String,
			default: '60%'
		}
	},
	components: {
		customTextEdit: defineAsyncComponent(() => import('@/components/common/customTextEdit/index.vue'))
	},
	watch: {
		dialogVisible: {
			handler(val) {
				if (!val) {
					this.formData = ''
					this.functionParms = []
				}
			}
		}
	},
	methods: {
		open(val, customData = [], index) {

			this.formData = val.bindinf
			if (val.functionParms) {
				this.functionParms = val.functionParms
			}
			this.customData = customData
			this.index = index
			this.dialogVisible = true
		},
		async submit() {
			this.$emit('submit', { formData: this.formData, functionParms: this.functionParms, index: this.index })
			this.dialogVisible = false
		}
	}
}
</script>

<style lang="scss">
.rich-text-edit-dialog {
  .el-dialog__header {
    padding: 12px 20px;
    background-color: #F2F2F2;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  
    .el-dialog__title {
      font-size: 16px;
      color: #231916;
      font-weight: 500;
    }
  
    .el-dialog__headerbtn {
      top: 0px;
    }
  }
  
  .el-dialog__body {
    padding: 16px 20px;
  }
  
  .el-dialog__footer {
    border-top: 1px solid #D8D8D8;
  }
}
</style>